import { IFaturamentoParams, IFaturamentoResponse } from "../requests/types";

export default class Faturamento {
  constructor(
    readonly response: IFaturamentoResponse | undefined,
    readonly filters?: IFaturamentoParams
  ) {}

  getFinancasSeries() {
    if (!this.response) return [];

    return this.response?.financas || [];
  }

  getDeclaradoSeries() {
    if (!this.response) return [];

    return this.response?.declarado || [0];
  }

  getFinancasCupom() {
    if (!this.response) return [];

    return this.response?.documentoFiscal || [];
  }

  todasEmpresasNaoPossuemDeclaracaoDeCupons() {
    return (
      this.response?.documentoFiscal === undefined ||
      this.response.documentoFiscal.length === 0
    );
  }

  possuiAlgumCupom() {
    return (
      (this.response?.documentoFiscal?.length || 0) > 0 &&
      this.response?.documentoFiscal?.some(
        (item) =>
          typeof item.valorDeclarado === "number" && item.valorDeclarado > 0
      )
    );
  }

  hasDifference(date: string[], dateComp: string[]) {
    const s = new Set(dateComp);

    return date.filter((x) => !s.has(x));
  }

  // lógica aplicada apenas pegano o length, porque aqui é apenas uma soma dos valores, idependente da empresa
  todasEmpresasPossuemCupons() {
    const cupom =
      this.response?.documentoFiscal?.map((cupom) => cupom.data) || [];
    const financas =
      this.response?.financas?.map((financas) => financas.data) || [];

    if (cupom.length == 0) return false;

    const diffs = this.hasDifference(cupom, financas);

    return diffs.length === 0;
  }

  empresasAguardandoProcessamento() {
    return (
      this.response?.declaradoPorEmpresa?.filter(
        (empresa) => empresa.declarado === null
      ) || []
    );
  }

  empresasComCertificadoInvalido() {
    return (
      this.response?.declaradoPorEmpresa?.filter(
        (empresa) => empresa.certificadoInvalido
      ) || []
    );
  }

  empresasLimiteSimples() {
    const empresasLimite = this.response?.insights?.limiteFaturamentoSimples;

    return empresasLimite || [];
  }

  empresasSublimiteSimples() {
    const empresasSublimite =
      this.response?.insights?.sublimiteFaturamentoSimples;

    return empresasSublimite || [];
  }
}
